export const addUtilityDataCollection = (webDataCollection) => ({
    type: 'ADD_UTILITY_DATA_COLLECTION',
    payload: webDataCollection
});

export const resetUtilityDataCollection = () => ({
    type: 'RESET_UTILITY_DATA_COLLECTION'
});